import { render, staticRenderFns } from "./friendNew.vue?vue&type=template&id=ae9ac882&"
import script from "./friendNew.vue?vue&type=script&lang=js&"
export * from "./friendNew.vue?vue&type=script&lang=js&"
import style0 from "./friendNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports